module.exports = __webpack_public_path__ + "ac6fa1a3ca93e95637cf5084e9dfad24.svg";